import { Injectable, inject } from '@angular/core';

import { MobileHelper } from '@frontend/sports/web/core/feature/mobile-helper';
import { HtmlNode, OnAppInit } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class SetFeatureClassesService implements OnAppInit {
    private htmlNode = inject(HtmlNode);
    private mobileHelper = inject(MobileHelper);

    onAppInit(): void {
        this.htmlNode.setCssClass('breadcrumbs-visible', true);
        this.htmlNode.setCssClass('is-android-native', this.mobileHelper.isAndroidNative);
    }
}
